import React from 'react';
import classes from 'classnames';
import styles from './title.module.scss';
import SVG from 'react-inlinesvg';
import { icons } from '@/school-management/utils/icons';
import BackButton from '@/components/BackButton/BackButton';

export interface titleProps {
  title?: string;
  MainTitle?: string;
  subTitle?: string;
  logo?: keyof typeof icons;
  style?: React.CSSProperties;
  buttonText?: string;
  linkTo?: string;
  onClick?: () => void;
  titleClassName?: string;
  subTitleClassName?: string;
  onBack?: () => void;
}

const Title: React.FC<titleProps> = ({
  title,
  MainTitle,
  subTitle,
  logo,
  style,
  buttonText,
  onClick,
  titleClassName,
  subTitleClassName,
  onBack,
}) => {
  return (
    <div className={styles.titleWrapper} style={style}>
      {MainTitle && (
        <div className={styles.mainTitle}>
          {logo && onBack && <BackButton onClick={onBack} />}
          <h1>{MainTitle}</h1>
        </div>
      )}
      {title && (
        <div
          className={classes(styles.titleContainer, {
            [titleClassName || '']: !!titleClassName,
          })}
        >
          <h2>{title}</h2>
          {buttonText && (
            <button type='button' onClick={onClick} className={styles.addMoreButton}>
              {buttonText}
            </button>
          )}
        </div>
      )}
      {subTitle && (
        <p
          className={classes(styles.subTitle, {
            [subTitleClassName || '']: !!subTitleClassName,
          })}
        >
          {subTitle}
        </p>
      )}
    </div>
  );
};

export default Title;
